import { useCallback } from 'react'

import { MovementDirection } from 'components/MovementDirection/MovementDirection'
import { Loading } from 'components/ui/Loading/Loading'
import { ContainerType, useEmptyContainersStock } from 'services/warehouse-containers/containers'
import { Warehouse } from 'services/warehouse-containers/warehouse'
import { ContainerTypeLink } from 'components/ContainerTypeLink/ContainerTypeLink'

export const RefillContainers = () => {
  const { isLoading, args, setArgs: setWarehouses, stock } = useEmptyContainersStock()

  const renderContainerTypeItem = (containerType: ContainerType, index: number) => (
    <ContainerTypeLink key={index} containerType={containerType} />
  )

  const renderContainerTypeList = useCallback(() => {
    if (isLoading) return <Loading />

    return <div>{stock?.map(renderContainerTypeItem)}</div>
  }, [stock?.length, isLoading])

  const handleOnSearch = (fromWarehouse: Warehouse, toWarehouse: Warehouse) => {
    setWarehouses({ from: fromWarehouse, to: toWarehouse })
  }

  return (
    <>
      <MovementDirection
        title="Пополнение"
        hint="Поиск потенциальных пустых контейнеров, которые могут быть перемещены на альтернативный склад."
        fromWarehouse={args.from}
        toWarehouse={args.to}
        onSearch={handleOnSearch}
      />
      {renderContainerTypeList()}
    </>
  )
}
